/**
 * Inserts an element into an array (operates on the array directly)
 * @param array the array to insert into
 * @param index the index at which to insert the element
 * @param element the element to insert
 * @returns the updated array
 */
export function arrayInsert(array, index, element) {
    if (index < 0) {
        index = array.length + index;
    }
    if (index > array.length) {
        throw new Error(`Index out of bounds: index ${index} was specified for an array of size ${array.length}`);
    }
    const left = array.slice(0, index);
    left.push(element);
    const right = array.slice(index);
    return left.concat(right);
}
//# sourceMappingURL=arrayInsert.js.map